module.exports = __webpack_public_path__ + "img/qus_2.56d8955c.png";